 const DownloadFile = (url, fileName) => {  
  fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.blob();
    })
    .then((blob) => {
      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = fileURL;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(fileURL);
      document.body.removeChild(a);
    })
    .catch((error) => {
      console.error("Error downloading file:", error);
    });
};

export default DownloadFile;
